import React, { useEffect } from 'react';
import { Box } from '@mui/system';
import Iframe from 'react-iframe';
import { QRCodeCanvas } from 'qrcode.react';

import orderApprovedStep1Image from '../../../../assets/images/orderApprovedStep1.png';
import orderApprovedStep2Image from '../../../../assets/images/orderApprovedStep2.png';
import orderApprovedStep3Image from '../../../../assets/images/orderApprovedStep3.png';

import {
  OrderApprovedScreenWrapper,
  OrderApprovedContentWrapper,
  OrderApprovedHeader,
  BoldText,
  NormalText,
  QrCodeImage,
  InfoRow,
  StepImage,
  TextColumn,
} from './styles';
import useConfigsStore from '../../store/configsStore';
import usePageStore from '../../store/pageStore';

export default function MethodAlreadySelected() {
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const order = useConfigsStore((state) => state.order);
  const setDisableHeader = usePageStore((state) => state.setDisableHeader);

  const selectedReturnMethod = order?.returnMethod?.index;
  const clientName = order?.client?.name;

  // CR
  const expressNumber = order?.returnMethod?.info?.expressNumber;
  const selectedLockerAddress =
    order?.returnMethod?.info?.selectedLockerAddress;
  // const qrCodeUrl = order?.returnMethod?.info?.qrCodeUrl;
  const crInternalOrderId = order?.returnMethod?.info?.crInternalOrderId;
  const qrCodeValue = `FOR_CUSTOMER_STORE|${crInternalOrderId}|${expressNumber}`;
  const orderApprovedTemplateEmailHtml =
    order?.returnMethod?.info?.orderApprovedTemplateEmailHtml;

  // Correios
  const correiosPostageNumber =
    order?.returnMethod?.info?.correiosPostageNumber;

  useEffect(() => {
    if (orderApprovedTemplateEmailHtml) {
      setDisableHeader(true);
    }
  }, [orderApprovedTemplateEmailHtml]);

  if (selectedReturnMethod === 1) {
    return orderApprovedTemplateEmailHtml ? (
      <div
        style={{
          width: '100%',
          height: 'calc(100vh - 50px)',
        }}
      >
        <Iframe
          src={'data:text/html;base64,' + orderApprovedTemplateEmailHtml}
          width="100%"
          height="100%"
          frameBorder={0}
        />
      </div>
    ) : (
      <OrderApprovedScreenWrapper
        fontFamily={devolutionPageConfigs?.fontFamily}
      >
        <OrderApprovedContentWrapper>
          <OrderApprovedHeader>
            Olá {clientName} este é seu pedido de devolução!
          </OrderApprovedHeader>
          <Box sx={{ minHeight: '20px' }} />
          <BoldText>Tudo pronto para fazer a devolução do seu pedido!</BoldText>
          <Box sx={{ minHeight: '20px' }} />
          <InfoRow>
            <StepImage src={orderApprovedStep1Image} />
            <TextColumn justify="flex-start" padding="10px 0 0 0">
              <NormalText textAlign="left">1. Embale seu pedido</NormalText>
            </TextColumn>
          </InfoRow>
          <Box sx={{ minHeight: '20px' }} />
          <InfoRow>
            <StepImage src={orderApprovedStep2Image} />
            <TextColumn justify="flex-start" padding="10px 0 0 0">
              <NormalText textAlign="left">
                {/* Leve seu pedido embalado até qualquer Locker do link abaixo:
                https://webview.cliqueretire.com.br/map?tags=MEFDCMG,MEFDC */}
                2. Leve seu pedido embalado até o Locker que escolheu:
                {selectedLockerAddress}.
              </NormalText>
            </TextColumn>
          </InfoRow>
          <Box sx={{ minHeight: '20px' }} />
          <InfoRow>
            <StepImage src={orderApprovedStep3Image} />
            <TextColumn justify="flex-start" padding="40px 0 0 0">
              <NormalText textAlign="left">
                3. Ao chegar no Locker apresente o QR
                Code abaixo no leitor do equipamento. Se tiver problemas com a leitura, você pode digitar
                o código: {expressNumber}
              </NormalText>
              <Box sx={{ height: '20px' }} />
              <NormalText textAlign="left">
                4. Escolha o tamanho do compartimento, deposite seu pacote com
                os itens e feche a porta da gaveta.
              </NormalText>
            </TextColumn>
          </InfoRow>
          <Box sx={{ minHeight: '20px' }} />
          <BoldText>Seu QR Code</BoldText>
          {/* <QrCodeImage src={qrCodeUrl} /> */}
          <QRCodeCanvas value={qrCodeValue} size={256} includeMargin />
          <BoldText>{expressNumber}</BoldText>
          <Box sx={{ minHeight: '15px' }} />
          <NormalText>
            - O pacote não deve medir mais que 34 x 48 x 40cm
          </NormalText>
          <Box sx={{ minHeight: '15px' }} />
          <NormalText>
            <NormalText>- O pacote não deve pesar mais que 15kg</NormalText>
          </NormalText>
          <Box sx={{ minHeight: '15px' }} />
          <NormalText>
            -Não se esquece de fechar a porta do compartimento
          </NormalText>
        </OrderApprovedContentWrapper>
      </OrderApprovedScreenWrapper>
    );
  } else if (selectedReturnMethod === 2) {
    return (
      <OrderApprovedScreenWrapper
        fontFamily={devolutionPageConfigs?.fontFamily}
      >
        <OrderApprovedContentWrapper>
          <OrderApprovedHeader>
            Olá {clientName} este é seu pedido de devolução!
          </OrderApprovedHeader>
          <Box sx={{ minHeight: '20px' }} />
          <BoldText>Tudo pronto para fazer a devolução do seu pedido!</BoldText>
          <Box sx={{ minHeight: '40px' }} />
          <InfoRow alignItems="flex-start">
            <BoldText textAlign="start">
              Siga as instruções abaixo para realizar sua devolução via
              Correios:
            </BoldText>
          </InfoRow>
          <Box sx={{ minHeight: '20px' }} />
          <InfoRow alignItems="flex-start">
            <BoldText>1 - Preparação do pacote:</BoldText>
          </InfoRow>
          <Box sx={{ minHeight: '10px' }} />
          <InfoRow alignItems="flex-start">
            <Box sx={{ minWidth: '30px' }} />
            <NormalText textAlign="start" keepTextAling>
              - Coloque os produtos desmontados na embalagem (pode ser a
              embalagem original ou em uma similar, como por exempo as caixas
              vendidas pelo Correios), junto com todos os itens que vieram com
              eles;Coloque os produtos desmontados na embalagem (pode ser a
              embalagem original ou em uma similar, como por exempo as caixas
              vendidas pelo Correios), junto com todos os itens que vieram com
              eles;
            </NormalText>
          </InfoRow>
          <Box sx={{ minHeight: '10px' }} />
          <InfoRow alignItems="flex-start">
            <Box sx={{ minWidth: '30px' }} />
            <NormalText textAlign="start" keepTextAling>
              - Lacre bem e, caso tenha, anexe a Nota Fiscal do lado de fora da
              caixa.
            </NormalText>
          </InfoRow>
          <Box sx={{ minHeight: '20px' }} />
          <InfoRow alignItems="flex-start">
            <BoldText>2 - Devolução:</BoldText>
          </InfoRow>
          <Box sx={{ minHeight: '10px' }} />
          <InfoRow alignItems="flex-start">
            <Box sx={{ minWidth: '30px' }} />
            <NormalText textAlign="start" keepTextAling>
              - Leve aos Correios e apresente o seguinte código de postagem:
            </NormalText>
          </InfoRow>
          <Box sx={{ minHeight: '10px' }} />
          <BoldText>{correiosPostageNumber}</BoldText>
          <Box sx={{ minHeight: '10px' }} />
          <InfoRow alignItems="flex-start">
            <Box sx={{ minWidth: '30px' }} />
            <NormalText textAlign="start" keepTextAling>
              - Atenção: esse código é válido por 15 dias corridos e só é aceito
              nas agências do tipo AC. (para verificar as agências disponíveis e
              seus tipos,{' '}
              {
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://mais.correios.com.br/app/index.php"
                >
                  clique aqui
                </a>
              }
              ).
            </NormalText>
          </InfoRow>
          <Box sx={{ minHeight: '10px' }} />
          <InfoRow alignItems="flex-start">
            <Box sx={{ minWidth: '30px' }} />
            <NormalText textAlign="start" keepTextAling>
              - Guarde o comprovante de postagem com você.
            </NormalText>
          </InfoRow>
          <Box sx={{ minHeight: '20px' }} />
          <InfoRow alignItems="flex-start">
            <NormalText textAlign="start" keepTextAling>
              Em caso de desistência, apenas não realizar a postagem.
            </NormalText>
          </InfoRow>
        </OrderApprovedContentWrapper>
      </OrderApprovedScreenWrapper>
    );
  }
}
